import { NextResponse } from "next/server";
import axios from "axios";
import { REDIRECT_URL } from '@/Utils/Other/Constant';
import { cookies } from "next/headers";

export async function POST(req) {
  const cookieStore = await cookies();
  const accessToken =
    cookieStore.get("iat")?.value || cookieStore.get("verifyUAT")?.value;

  let requestData;
  try {
    requestData = await req.json();
    const { code } = requestData;

    const propsData = {
      code: code,
      client_id: process.env.GOOGLE_CLIENT_ID,
      redirect_uri: REDIRECT_URL,
      client_secret: process.env.GOOGLE_CLIENT_SECRET_ID,
      grant_type: "authorization_code",
    };

    const response = await axios.post(
      "https://oauth2.googleapis.com/token",
      null,
      {
        params: propsData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    let user_info = null;
    if (response.data.id_token) {
      const tokenInfoResponse = await axios.get(
        "https://oauth2.googleapis.com/tokeninfo",
        { params: { id_token: response.data.id_token } }
      );
      user_info = tokenInfoResponse.data;
    }

    return NextResponse.json({ data: { ...response.data, user_info } });
  } catch (error) {
    let payload;

    if (error.response) {
      payload = {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      };
    } else {
      payload = {
        message: error.message,
      };
    }

    let body = {
      module: "google_authorization_code",
      name: error.response?.data?.error || "unknown_error",
      message: error.response?.data?.error_description || error.message,
      context: {
        url: "https://oauth2.googleapis.com/token",
        code: requestData?.code,
        type: type || "login",
      },
    };

    if (accessToken) {
      try {
        await axios.post(`${BaseURL}auth/error-log`, body, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        });
      } catch (logError) {
        console.error("Error logging to backend:", logError);
      }
    }

    return NextResponse.json(
      { error: payload },
      { status: error.response ? error.response.status : 500 }
    );
  }
}